const roles = {
  ADMIN: 'ROLE_ADMIN',
  ASSETS_ADMIN: 'ROLE_ASSETS_ADMIN',
  DASHBOARD_USER: 'ROLE_DASHBOARD_USER',
  BULK_PURCHASE_ADMIN: 'ROLE_BULK_PURCHASE_ADMIN',
};

export default roles;